import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_debounced_function } from '@/hooks/debounce/use_debounced_function';
import { use_slice_ml_asset } from '@/hooks/store/use_slices';
import { use_table_columns_diffusion_models_ud } from '@/hooks/tables/use_table_columns_diffusion_models_ud';
import { local_ml_asset_set_current_table_page_settings } from '@/state/diffusion_models_ud/local_ml_asset_set_current_table_page_settings';
import { DTODiffusionModelUDBase } from '@shared/dto/+model/sd/_base/dto_diffusion_model_ud_base';
import { DTODiffusionModelsTablePageSettingsUD } from '@shared/dto/+model/table/dto_diffusion_models_table_page_settings_ud';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__sort_direction } from '@shared/dto/_database_entity/ENUM__sort_direction';
import { FIELD_OF_TYPE } from '@shared/types/types';
import { ColumnDef } from '@tanstack/react-table';
import { useCallback } from 'react';
import { DiffusionModelsTableBase } from '../_base/diffusion_models_table_base';

export function DiffusionModelsTableUD() {
  const dispatch = use_dispatch();

  const { current_table_page_settings, current_table } = use_slice_ml_asset(['current_table_page_settings', 'current_table']);

  const columns = use_table_columns_diffusion_models_ud() as ColumnDef<DTODiffusionModelUDBase>[];

  /*
   * METHODS
   */

  const try_update_sort_value = useCallback(
    (column_name: string, sort_direction: number) => {
      const sort_columns_map_new = new MAP__serializable<FIELD_OF_TYPE<DTODiffusionModelUDBase>, number>();

      if (column_name !== '' && sort_direction !== ENUM__sort_direction.NONE) {
        sort_columns_map_new.set(column_name as FIELD_OF_TYPE<DTODiffusionModelUDBase>, sort_direction);
      }

      let current_table_page_settings_new = current_table_page_settings.clone({ sort_columns_map: sort_columns_map_new });

      dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
    },
    [current_table_page_settings, dispatch],
  );

  const try_update_sort_value_debounced = use_debounced_function(try_update_sort_value, CONSTANTS_TIME__client.DEBOUNCE_LOAD_DIFFUSION_MODELS);

  const try_update_index_page_settings = useCallback(
    (first_row_index: number) => {
      let index_page = DTODiffusionModelsTablePageSettingsUD.index_row_to_index_page(first_row_index);

      if (index_page == current_table_page_settings.index_page) return;

      let current_table_page_settings_new = current_table_page_settings.clone({ index_page });

      dispatch(local_ml_asset_set_current_table_page_settings(current_table_page_settings_new));
    },
    [current_table_page_settings, dispatch],
  );

  /*
   * HTML
   */

  return (
    <DiffusionModelsTableBase
      sort_keys={DTODiffusionModelUDBase.SORT_KEYS}
      stub_template={DTODiffusionModelUDBase.CREATE_STUB()}
      {...{ current_table_page_settings, current_table, columns }}
      //functions
      on_sort_updated={try_update_sort_value_debounced}
      on_first_index_updated={try_update_index_page_settings}
    />
  );
}
